import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { PersonsByIdNumCtrlDig } from '../../../../core/entities/personsByIdNumCtrlDig.model';
import { Representants } from 'src/app/core/entities/representants.model';
import { RepositoryService } from 'src/app/core/repositories/repository.service';
import { SelectItem } from 'primeng/api';
import * as _ from 'lodash';
import { PETICIONES } from 'src/app/core/utils/constants';

@Injectable()
export class DialogsRepresentantService {

    representant: Representants = new Representants();
    allRepresentant: Representants[] = new Array<Representants>();
    nif: string;

    optionsRepresentant: SelectItem[] = [];
    optionsRepresentantBase: SelectItem[] = [];

    constructor(private repositoryService: RepositoryService) { }

    init(data: any): Observable<boolean> {
        return forkJoin([this.repositoryService.doGet(PETICIONES.personsByIdNumCtrlDig.findAll + "/" + data.nif)]).pipe(map(dataGroup => {
            this.optionsRepresentantBase.push({ value: null, label: "" });
            this.allRepresentant = dataGroup[0].representants;
            for (let i = 0; i < this.allRepresentant.length; i++) {
                this.optionsRepresentantBase.push({ value: this.allRepresentant[i].entitatcodi, label: this.allRepresentant[i].entitatnom });
              }
            this.optionsRepresentant = this.optionsRepresentantBase;
            this.optionsRepresentantBase = [];
            return true;
        }));
    }
}